import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import Select from "react-select";
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import KartuUjianPDF from './KartuKodeUjina.js';
import { PDFDownloadLink } from "@react-pdf/renderer";

const JadwalUjian = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        hari: "Senin",
        tgl: "",
        sesi: "1",
        data_id: "",
        nama_guru: "",
        durasi: 120,
        data: []
    }); // State untuk menyimpan daftar kelas
    const pdfRef = useRef();
    const [getUjian, setUjian] = useState([]); // State untuk menyimpan daftar kelas
    const [dataGuru, setGuru] = useState([]); // State untuk menyimpan daftar kelas
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState("Hari ini"); // Default: "Hari ini"
    const [isEditing, setIsEditing] = useState(false);
    const [informasiAkun, setInformasiAkun] = useState(null); // State untuk menyimpan informasi akun
    const [plhjadwal, setPlhJadwal] = useState([]); // State untuk menyimpan informasi akun
    const [npsn, setNpsn] = useState("");
    const [loading, setLoading] = useState(true);


    const formatTanggal = (date) => {
        return new Intl.DateTimeFormat('id-ID', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: 'Asia/Jakarta', // Pastikan menggunakan zona waktu lokal
        })
            .format(date)
            .split('/').reverse().join('-'); // Format ke yyyy-MM-dd
    };

    const getJadwal = useCallback(async () => {
        try {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            const nextWeek = new Date(today);
            nextWeek.setDate(today.getDate() + 7);


            let q = query(
                collection(db, "jadwal"),
                where("npsn", "==", npsn),
                orderBy("tgl", "desc") // Sesuaikan dengan struktur Firestore Anda
            );

            // Ubah Date ke format string yang sesuai dengan Firestore
            const todayStr = formatTanggal(today);
            const tomorrowStr = formatTanggal(tomorrow);
            const nextWeekStr = formatTanggal(nextWeek);


            // Tambahkan filter berdasarkan pilihan
            if (filter === "Hari ini") {
                q = query(q, where("tgl", "==", todayStr));
            } else if (filter === "Besok") {
                q = query(q, where("tgl", "==", tomorrowStr));
            } else if (filter === "1 Minggu") {
                q = query(q, where("tgl", ">=", todayStr), where("tgl", "<=", nextWeekStr));
            }

            const ujianSnap = await getDocs(q);

            if (ujianSnap.empty) {
                setData([])
            }

            const ujianData = ujianSnap.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));

            setData(ujianData);
        } catch (error) {
            console.log(error);
            Swal.fire("Error!", "Terjadi kesalahan", "error");
        }
    }, [npsn, filter]);
    const getDataRefrensi = useCallback(async () => {


       try {
                // Kirim request ke server dengan header level user
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/pendidik/getsubtes`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch kelas");
                }

                const data = await response.json();

                setUjian(data.data);
            } catch (error) {
                 Swal.fire("Error!", error.message || 'Something went wrong', "error");
            }
    }, []);



    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            console.error("Token required");
            return; // Jika tidak ada token, hentikan eksekusi
        }

        try {
            // Decode payload dari token JWT
            const decoded = jwtDecode(authToken);
            setInformasiAkun(decoded); 
        } catch (error) {
            console.error("Invalid token:", error);
            navigate('/login'); // Jika token tidak valid, arahkan ke halaman login
            return;
        }


    }, []);
    useEffect(() => {
        console.log(localStorage.getItem("authToken"));
        getDataRefrensi();

        if ($.fn.dataTable.isDataTable(".table")) {
            $(".table").DataTable().destroy();
        }

        // ** Ambil Tanggal untuk Filter **
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const nextWeek = new Date(today);
        nextWeek.setDate(today.getDate() + 7);

        const formatTanggal = (date) => date.toISOString().split("T")[0];

        const todayStr = formatTanggal(today);
        const tomorrowStr = formatTanggal(tomorrow);
        const nextWeekStr = formatTanggal(nextWeek);

        $(".table").DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/admin/refrensi/getUjian`,
                type: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
                data: function (d) {
                    // ** Tambahkan Filter Tanggal ke Permintaan AJAX **
                    if (filter === "Hari Ini") {
                        d.tgl = todayStr;
                    } else if (filter === "Besok") {
                        d.tgl = tomorrowStr;
                    } else if (filter === "1 Minggu") {
                        d.startDate = todayStr;
                        d.endDate = nextWeekStr;
                    }
                },
                dataSrc: function (json) {
                    if (!json.data || json.data.length === 0) {
                        return []; // Pastikan DataTables tetap berfungsi meskipun data kosong
                    }
                    return json.data;
                },
            },
            columns: [
                { 
                    data: null, 
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
                { 
                    data: null,
                    render: function (data) {
                        return `<b>${data.id_ujian}</b>`;
                    }
                },
                { 
                    data: null,
                    render: function (data) {
                        return `<b>${data.nama_rombel} || ${data.nama_mapel}</b>`;
                    }
                },
                {
                    data: null,
                    render: function (data) {
                        let soalCount = 0;
                        try {
                            let soalArray = JSON.parse(data.soal || "[]");
                            if (Array.isArray(soalArray)) {
                                soalCount = soalArray.length;
                            }
                        } catch (error) {
                            console.error("Error parsing soal:", error);
                        }
                        return `<b>${soalCount}</b>`;
                    }
                },
                { data: "durasi" },
                {
                    data: null,
                    render: function (data, type, row) {
                        return `
                        <a href="/pendidik/hasilujian?kode=${row.id_ujian}" class="avtar avtar-xs mx-1 btn-link-secondary" title='Hasil'><center>Hasil</center></a>
                        <a href="/pendidik/viewevaluasi?id_ujian=${row.id_ujian}" title='Lihat Soal' class="avtar avtar-xs mx-1 btn-link-secondary">
                            <i class="ti ti-eye f-20"></i>
                        </a>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        return `
                        <a data-bs-toggle="modal" data-bs-target="#ujianModal" class="edit-btn avtar avtar-xs mx-1 btn-link-secondary" data-row='${JSON.stringify(row)}'>
                            <i class="ti ti-edit f-20"></i>
                        </a>
                        <a href="#" class="delete-btn avtar avtar-xs mx-1 btn-link-danger" data-id="${row.id_ujian}">
                            <i class="ti ti-trash f-20"></i>
                        </a>`;
                    }
                }
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data",
                loadingRecords: "Loading....",
                zeroRecords: "Belum memiliki data",
            },
        });
    
        return () => {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy();
            }
        };
    }, []);// Inisialisasi ulang hanya ketika `kelas` berubah
    $(document).off("click", ".edit-btn").on("click", ".edit-btn", function () {
        let rowData = $(this).data("row");
        console.log(rowData)
        if (rowData) {
            handleEdit(rowData);
        } else {
            console.error("Data tidak ditemukan.");
        }
    });
    // Event listener untuk tombol Delete menggunakan SweetAlert2
    $(document).on("click", ".delete-btn", function (e) {
        e.preventDefault();
        let id = $(this).data("id");
    
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Data akan dihapus secara permanen!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/hapusujian`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem('authToken')}`
                    },
                    body: JSON.stringify({ id_ujian : id })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        Swal.fire("Terhapus!", "Data berhasil dihapus.", "success");
                        $('.table').DataTable().ajax.reload(); // Reload DataTable setelah hapus
                    } else {
                        Swal.fire("Gagal!", data.message, "error");
                    }
                })
                .catch(error => {
                    Swal.fire("Error!", "Terjadi kesalahan saat menghapus data.", "error");
                });
            }
        });
    });

    // Handle perubahan input form
    const handleChange = (e) => {
        const { name, value } = e.target;
        let selectedText = "";
        if (name === "kode" || name === "data_id") {
            selectedText = e.target.options[e.target.selectedIndex].text;
        }


        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
            ...(name === "kode" && { nama_ujian: selectedText }),
            ...(name === "data_id" && { nama_guru: selectedText })
        }));
        console.log(formData)
    };



    // Buka modal untuk edit data
    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
    };

    // Reset form untuk tambah data baru
    const handleNew = () => {
        setIsEditing(false);

    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Fungsi untuk membuat kode unik
        const generateRandomCode = () =>
            (Date.now().toString(36) + Math.random().toString(36).substring(2, 3)).toUpperCase();

        let kodeid = generateRandomCode(); // Gunakan `let` karena bisa diubah nanti

        try {
            // Kirim data ke backend
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/inputjawdal`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log(result.message);

            // Jika sedang mengedit, gunakan kode lama
            if (isEditing) {
                kodeid = formData.kode;
            }

            // Data yang akan disimpan di Firestore
            const datainf = {
                ...formData,  // Salin semua data dari formData
                kode: kodeid,  // Tambahkan kode unik
                npsn: informasiAkun.npsn,
            };

            // Simpan ke Firestore
            await setDoc(doc(db, "jadwal", kodeid), datainf);

            // Notifikasi sukses
            Swal.fire("Berhasil!", "Jadwal berhasil disimpan!", "success");

            // Refresh daftar jadwal
            getJadwal(informasiAkun.npsn);

            // Reset form
            setFormData({
                ...formData,
              
                data_id: "",
                nama_guru: "",
                data: []
            });

        } catch (error) {
            console.error("Terjadi kesalahan:", error);
            Swal.fire("Error!", "Terjadi kesalahan saat menyimpan jadwal.", "error");
        }
    };


    const handleChangeSelected = (selectedOptions) => {
        if (!selectedOptions) return;
        console.log(selectedOptions)

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;

        setFormData((prevData) => ({
            ...prevData,
            data: selectedData, // Perbaiki agar langsung pakai `selectedData`
        }));

        console.log("Updated Form Data:", formData);
    };

    const handleChangePenawasg = (selectedOptions) => {
        if (!selectedOptions) return;

        // Pastikan `selectedOptions` dalam bentuk array
        const selectedData = selectedOptions;

        setFormData((prevData) => ({
            ...prevData,
            data_id: selectedData, // Perbaiki agar langsung pakai `selectedData`
        }));

        console.log("Updated Form Data:", formData);
    };

    const handleDeleteSoal = async (kode) => {
        if (!kode) {
            alert("ID soal tidak valid.");
            return;
        }

        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Soal yang dihapus tidak bisa dikembalikan!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Batal"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteDoc(doc(db, "jadwal", kode));

                    Swal.fire("Terhapus!", "Soal berhasil dihapus.", "success");

                    getJadwal(informasiAkun.npsn);
                } catch (error) {
                    console.error("Terjadi kesalahan saat menghapus soal:", error);
                    Swal.fire("Error!", "Gagal menghapus soal.", "error");
                }
            }
        });
    };

    const handlePlhJadwal = (e, item) => {
        if (e.target.checked) {
            setPlhJadwal((prev) => [...prev, item]); // Tambahkan ke list jika dicentang
        } else {
            setPlhJadwal((prev) => prev.filter((selected) => selected.id !== item.id)); // Hapus dari list jika tidak dicentang
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setPlhJadwal(data); // Pilih semua data
        } else {
            setPlhJadwal([]); // Kosongkan jika tidak dicentang
        }
    };

    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col"><small className="text-muted">Refrensi</small><h3>Jadwal Ujian</h3></div>

                                        <div className='col-auto'>
                                            <select className="form-select p-r-35" value={filter} onChange={(e) => setFilter(e.target.value)}>
                                                <option value="Hari ini">Hari ini</option>
                                                <option value="Besok">Besok</option>
                                                <option value="1 Minggu">1 Minggu</option>
                                                <option value="Semua">Semua</option>
                                            </select>
                                        </div>
                                        <div className='col-auto'>
                                            <button data-bs-toggle="modal" data-bs-target="#ujianModal" onClick={handleNew} type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Data Baru</button>
                                            {/* <button data-bs-toggle="modal" data-bs-target="#ujianModal"   type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i> Kirim Kode Kepada Pengawas</button> */}
                                            {plhjadwal.length > 0 ? (
                                                <PDFDownloadLink
                                                    className="btn btn-primary d-inline-flex"
                                                    document={<KartuUjianPDF data={plhjadwal} />}
                                                    fileName="kartu_ujian.pdf"
                                                >
                                                    {({ loading }) => (loading ? "Loading PDF..." : "Download Kartu")}
                                                </PDFDownloadLink>
                                            ) : (
                                                <button data-bs-toggle="modal" data-bs-target="#ujianModal" type="button" className="btn btn-primary disabled"> Download Kartu</button>

                                            )}
                                        </div>
                                    </div>
                                    <hr />
                                    {/* Tabel kelas */}
                                 <table className="table table-hover datatable-table">
                                        <thead>
                                            <tr>
                                                <th width="50"><input
                                                    name="jdl"
                                                    className='form-check-input'

                                                    type="checkbox"
                                                    onChange={(e) => handleSelectAll(e)}
                                                    checked={plhjadwal.length === data.length && data.length > 0}
                                                /> Semua
                                                </th>
                                                <th width="50">#</th>
                                                <th scope="col">Ujian (Kode)</th>
                                                <th width="50">Hari (Sesi)</th>
                                                <th width="50">Daftar Ujian</th>
                                                <th width="50"><center>Pengawas</center></th>
                                                <th width="50"><center>Action</center></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        
                                        </tbody>
                                    </table>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Input/Edit */}
            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{isEditing ? "Edit Kelas" : "Tambah Kelas"}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Ruang Ujian</label>
                                <input type="text" className="form-control" name="ruang" value={formData.ruang} onChange={handleChange} required />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Tanggal Ujian</label>
                                <input type="date" className="form-control" name="tgl" value={formData.tgl} onChange={handleChange} required />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Sesi Ujian</label>
                                <input type="number" className="form-control" name="sesi" value={formData.sesi} onChange={handleChange} required />

                            </div>
                            <div className="mb-3">
                                <label className="form-label">Pengawas</label>
                                <Select
                                    options={dataGuru?.guru || []}
                                    required
                                    name="data_id"
                                    getOptionLabel={(e) => e.nama} // Menampilkan `nama` di dropdown
                                    getOptionValue={(e) => e.data_id} // Menggunakan `data_id` sebagai value
                                    value={formData.data_id}
                                    onChange={handleChangePenawasg}
                                    placeholder="Pilih Guru..."
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Durasi (Menit)</label>
                                <input type="number" className="form-control" name="durasi" value={formData.durasi} onChange={handleChange} required />
                            </div>
                            <div className="mb-3">
                            <label className="form-label">Ujian</label>
                            <Select
                                options={Array.isArray(getUjian) ? getUjian : []} // Pastikan getUjian adalah array
                                isMulti
                                name="kode"
                                getOptionLabel={(e) => `${e.nama_rombel} - ${e.nama_mapel} - ${e.nama}`}
                                getOptionValue={(e) => e.id}
                                value={
                                    Array.isArray(getUjian) && Array.isArray(formData?.kode)
                                        ? getUjian.filter((option) => 
                                            formData.kode.some((id) => id?.toString() === option.id?.toString())
                                        )
                                        : []
                                }
                                onChange={handleChangeSelected}
                                placeholder="Pilih Ujian..."
                            />
                        </div>


                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type="onSubmit" className="btn btn-primary"
                                data-bs-dismiss="modal"
                            >
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
    );
};

export default JadwalUjian;
